import { useEffect, useState } from 'react';
import * as client from 'src/services/client';

export const useSuiteStatuses = (): any[] => {
  const [suiteStatuses, setSuiteStatuses] = useState<any[]>([]);

  useEffect(() => {
    const fetchSuiteStatuses = async () => {
      const response: any = await client.getSuiteStatuses();

      if (!response || (response.status !== 200 && !response.ok)) {
        return;
      }

      const responseJson: any = await response.json();
      setSuiteStatuses(responseJson);
    };

    fetchSuiteStatuses();
  }, []);

  return suiteStatuses;
};
